import type { Location } from '../model'

export const getLocationName = (value: Location) => {
  const { type, displayName, name } = value

  return type && type !== 'г' ? `${displayName || name} (${type})` : displayName || name
}
